import { isAllowedUri } from "./utils/validateUri";
export const navigate = (url, target) => {
    if (!isAllowedUri(url.toLowerCase())) {
        return false;
    }
    if (target != null) {
        window.open(url, target);
    }
    else {
        window.location.href = url;
    }
    return true;
};
